export const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
  return documentOrOptions.document ? documentOrOptions : {
    document: documentOrOptions,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
  return queryOrOptions.query ? queryOrOptions : {
    query: queryOrOptions,
    variables: variables,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
  return documentsOrOptions.documents ? documentsOrOptions : {
    documents: documentsOrOptions,
    requestHeaders: requestHeaders,
    signal: undefined
  };
};
export const parseRequestExtendedArgs = function (urlOrOptions, document) {
  for (var _len = arguments.length, variablesAndRequestHeaders = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    variablesAndRequestHeaders[_key - 2] = arguments[_key];
  }
  const [variables, requestHeaders] = variablesAndRequestHeaders;
  return urlOrOptions.document ? urlOrOptions : {
    url: urlOrOptions,
    document: document,
    variables,
    requestHeaders,
    signal: undefined
  };
};
export const parseRawRequestExtendedArgs = function (urlOrOptions, query) {
  for (var _len2 = arguments.length, variablesAndRequestHeaders = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    variablesAndRequestHeaders[_key2 - 2] = arguments[_key2];
  }
  const [variables, requestHeaders] = variablesAndRequestHeaders;
  return urlOrOptions.query ? urlOrOptions : {
    url: urlOrOptions,
    query: query,
    variables,
    requestHeaders,
    signal: undefined
  };
};